<div *ngIf="!loader" class="col-xl-12 vh-100">
    <ng-scrollbar #scrollable tr track="all" pointerEventsMethod="scrollbar">
        <div class="d-inline-block list-head-details">Broj: {{task.identifier}}</div>
        <div class="d-inline-block btp-close-button float-right">
            <button (click)="onClose()" type="button" class="close"
                    aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="full-width no-padding mt-2 cursor"
             [routerLink]="['/view-task',task._id]"
        >
            <h1 class="mb-0">{{task.title}}</h1>
            <p>{{createdByText}}</p>
        </div>
        <div class="full-width no-padding">
            <button class="no-border text-white" [ngClass]="statusClass"

                    type="button"
            >
                {{task.status}}
            </button>
        </div>

        <div class="full-width mt-4">
            <label style="font-size: 16px;
    font-weight: 600;">OPIS</label>
            <p *ngIf="task.description !==''" class="mt-1"
               style="letter-spacing: 0.4px;font-size: 14px;">{{task.description}}</p>
            <p *ngIf="task.description ==''"
               class="mt-1"
               style="letter-spacing: 0.4px;font-size: 14px;color: #8080806b;">Nema opisa.</p>
        </div>

        <div class="full-width">
            <app-attachment-thumbnails *ngFor="let attachment of task.attachments"
                                       [attachment]="attachment"
                                       [removePermission]="false">

            </app-attachment-thumbnails>


        </div>

        <div class="full-width mt-4">
            <label style="font-size: 16px;
    font-weight: 600;">DETALJI</label>

            <div class="container" id="bts-details">

                <div id="taskAssigned" class="row justify-content-start">
                    <div class="col-4 col-sm-8 col-md-7 col-lg-6 col-xl-6 px-0">
                        <span class="list-head-details">Izvršilac</span>
                    </div>
                    <div class="col-auto px-0">
                        <div class="d-inline-block" *ngFor="let item of assigned">
                            <app-avatar [personalStyle]="'margin-left:5px'" [assigned]="item"
                                        [avatarWidth]="25"></app-avatar>
                        </div>
                    </div>
                </div>


                <div id="taskValidators" class="row justify-content-start mt-2">
                    <div class="col-4 col-sm-8 col-md-7 col-lg-6 col-xl-6 px-0">
                        <span class="list-head-details">Validatori</span>
                    </div>
                    <div class="col-auto px-0">
                        <div class="d-inline-block" *ngFor="let item of validators">
                            <app-avatar [personalStyle]="'margin-left:5px'" [assigned]="item"
                                        [avatarWidth]="25"></app-avatar>
                        </div>
                    </div>
                </div>

                <div id="deadline" class="row justify-content-start mt-2">
                    <div class="col-4 col-md-6 col-lg-6 col-xl-6 px-0">
                        <span class="list-head-details">Rok za izvršenje</span>
                    </div>
                    <div class="col-auto px-0" style="min-height: 30px;">
                        {{task.deadline | date:'dd.MM.yyyy hh:mm'}}h
                    </div>
                </div>
                <div *ngIf="task.tags.length>0" id="taskTags" class="row justify-content-start mt-2">
                    <div class="col-4 col-sm-8 col-md-7 col-lg-6 col-xl-6 px-0">
                        <span class="list-head-details">Tagovi</span>
                    </div>
                    <div class="col-4 px-0">
                       <span style="background: #4bc66c" class="badge badge-success ml-1"
                             *ngFor="let tag of task.tags">{{tag}}</span>
                    </div>
                </div>

                <div id="sprint" class="row justify-content-start mt-2">
                    <div class="col-4 col-md-6 col-lg-6 col-xl-6 px-0 mt-2">
                        <span class="list-head-details">Sprint</span>
                    </div>
                    <div class="col-auto px-0" style="min-height: 30px;">
                        <div class="position-fixed d-inline-flex mb-3">
                            <input class="form-control no-border p-0"
                                   type="text"
                                   placeholder="Izaberi sprint"
                                   matInput
                                   style="caret-color:transparent;
                                   max-height: 30px !important;"
                                   [(ngModel)]="searchText"
                                   [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let sprint of sprints | searchPipe:searchText:'name'"
                                            [value]="sprint.name"
                                            (click)="setSprint(sprint._id)">
                                    {{sprint['name']}}
                                </mat-option>
                            </mat-autocomplete>
                            <div class="input-group-append ml-2 mt-2">
                                <a class=" -align-left no-padding" (click)="removeSprint()">
                                    <mat-icon class="pointer" style="font-size: 16px;cursor: pointer;color: black;">
                                        delete
                                    </mat-icon>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>


            </div>


        </div>

        <div class="full-width mt-4">
            <label style="font-size: 16px;
    font-weight: 600;">KOMENTARI</label>

            <div class="container mb-5 mt-4 p-1">


                <div id="addingComment" class="media">
                    <app-avatar avatarWidth="50" [assigned]="loggedInUser"
                                personalStyle=""></app-avatar>
                    <div class="media-body ml-2">
                        <div class="col-12 no-padding">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 no-padding  containe">
                                <div class="input-group">
                                        <textarea class="form-control"
                                                  aria-label="With textarea"
                                                  [(ngModel)]="commentText"
                                                  style="border: none;outline: none;background: #eaeaea;border-radius: 9px;"
                                                  (keydown.enter)="addComment()"
                                                  placeholder="+ tekst komentara"

                                        ></textarea>
                                    <div class="input-group-prepend">
                                        <button title="Dodaj dokument" (click)="onFileUploadClick()"
                                                style="background-color: #ffffff;
    font-size: 20px;
    border-radius: 10px;
    border-color: #ffff;" type="button" class=" btn btn-primar"><i
                                                class="fa fa-paperclip"></i>

                                        </button>
                                        <button title="Dodaj komentar"
                                                [disabled]="commentText =='' && commentAttachments.length==0"
                                                (click)="addComment()"
                                                type="button" class="ml-2 btn btn-primar btp-comment-button"><i
                                                class="fa fa-check"></i>
                                        </button>
                                        <input type="file"
                                               style="display: none"
                                               multiple="multiple"
                                               id="fileUpload" name="fileUpload[]"
                                               (change)="upload($event)"
                                               #fileUpload>
                                    </div>

                                </div>


                            </div>
                            <div id="newCommentAttachments"
                                 class="col-sm-12 col-12 no-padding-left">
                                <div class="pl-0 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                     *ngFor="let item of commentAttachments">
                                    <app-attachment-thumbnails
                                            (deleteFileEmitter)="deleteFileHandler($event)"
                                            [removePermission]="true"
                                            [attachment]="item"></app-attachment-thumbnails>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>


                <div class="card2 mt-3">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <app-comment-item class="commentItem"
                                                      [commentData]="comment"
                                                      *ngFor="let comment of comments">

                                    </app-comment-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </ng-scrollbar>
</div>
